import "./main.css";
import { jsxs as o, Fragment as L, jsx as r } from "react/jsx-runtime";
import { useState as S, createContext as Q, useContext as X, useCallback as Z, useEffect as ee, useMemo as T, forwardRef as ne, Fragment as te, useId as pe } from "react";
import { Modal as be, Button as N, Popover as ye, FormGroup as re, ValidatedOptions as C, Select as le, SelectVariant as Ce, SelectOption as ae, Switch as Ie, TextInput as ie, TextArea as we, NumberInput as Te, AlertGroup as Se, Alert as ke, AlertVariant as F, AlertActionCloseButton as Ne, InputGroup as se, ButtonVariant as H, Checkbox as xe, Radio as Oe, Text as Ae, Title as Ve, Card as qe, CardHeader as Le, CardTitle as _e, CardBody as Re, Grid as Fe, GridItem as j, PageSection as De, JumpLinks as Pe, JumpLinksItem as Ee } from "@patternfly/react-core";
import { useFormContext as E, Controller as O, useController as oe, FormProvider as Me, useWatch as $e } from "react-hook-form";
import { HelpIcon as G, CubeIcon as He, PaypalIcon as je, InstagramIcon as Ge, BitbucketIcon as Be, MicrosoftIcon as Ue, TwitterIcon as Je, StackOverflowIcon as We, OpenshiftIcon as Ke, LinkedinIcon as ze, GoogleIcon as Ye, GitlabIcon as Qe, FacebookSquareIcon as Xe, GithubIcon as Ze, MinusCircleIcon as en, PlusCircleIcon as nn } from "@patternfly/react-icons";
import { get as B } from "lodash-es";
const Hn = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: t,
  buttonTitle: l,
  isDisabled: a,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: d,
  component: m = N,
  children: u,
  ...h
}) => {
  const [f, g] = S(!1);
  return /* @__PURE__ */ o(L, { children: [
    /* @__PURE__ */ r(
      m,
      {
        variant: i,
        onClick: () => g(!0),
        isDisabled: a,
        "data-testrole": s,
        children: l
      }
    ),
    /* @__PURE__ */ r(
      be,
      {
        variant: "small",
        ...h,
        title: e,
        isOpen: f,
        onClose: () => g(!1),
        actions: [
          /* @__PURE__ */ r(
            N,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                g(!1), d();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ r(
            N,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => g(!1),
              children: t
            },
            "cancel"
          )
        ],
        children: u
      }
    )
  ] });
};
function tn(e, n) {
  const t = Q(n);
  return t.displayName = e, t;
}
function rn(e) {
  return e != null;
}
function ln(e) {
  const n = X(e);
  if (rn(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function an(e, n, t) {
  const [l, a] = S(
    () => e.getItem(n) ?? t
  ), i = Z((s) => {
    a(s), e.setItem(n, s);
  }, []);
  return ee(() => {
    a(e.getItem(n) ?? t), window.addEventListener("storage", s);
    function s(d) {
      d.storageArea === e && (d.key === null || d.key === n) && a(d.newValue ?? t);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [l, i];
}
function sn(e, n, t) {
  const l = T(
    () => JSON.stringify(t),
    [t]
  ), [a, i] = an(
    e,
    n,
    l
  ), s = T(() => JSON.parse(a), [a]), d = Z(
    (m) => i(JSON.stringify(m)),
    []
  );
  return [s, d];
}
const ce = tn(
  "HelpContext",
  void 0
), on = () => ln(ce), jn = ({ children: e }) => {
  const [n, t] = sn(localStorage, "helpEnabled", !0);
  function l() {
    t(!n);
  }
  return /* @__PURE__ */ r(ce.Provider, { value: { enabled: n, toggleHelp: l }, children: e });
}, de = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: t = !0,
  unWrap: l = !1
}) => {
  const { enabled: a } = on();
  return a ? /* @__PURE__ */ r(ye, { bodyContent: e, children: /* @__PURE__ */ o(L, { children: [
    !l && /* @__PURE__ */ r(
      "button",
      {
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (i) => i.preventDefault(),
        className: "pf-c-form__group-label-help",
        children: /* @__PURE__ */ r(G, { noVerticalAlign: t })
      }
    ),
    l && /* @__PURE__ */ r(G, { noVerticalAlign: t })
  ] }) }) : null;
}, A = ({
  name: e,
  label: n,
  labelIcon: t,
  error: l,
  children: a,
  ...i
}) => /* @__PURE__ */ r(
  re,
  {
    label: n || e,
    fieldId: e,
    labelIcon: t ? /* @__PURE__ */ r(de, { helpText: t, fieldLabelId: e }) : void 0,
    helperTextInvalid: l?.message,
    validated: l ? C.error : C.default,
    ...i,
    children: a
  }
), cn = ({
  name: e,
  label: n,
  options: t,
  controller: l,
  variant: a,
  labelIcon: i,
  ...s
}) => {
  const {
    control: d,
    formState: { errors: m }
  } = E(), [u, h] = S(!1);
  return /* @__PURE__ */ r(
    A,
    {
      name: e,
      label: n,
      isRequired: l.rules?.required === !0,
      error: m[e],
      labelIcon: i,
      children: /* @__PURE__ */ r(
        O,
        {
          ...l,
          name: e,
          control: d,
          render: ({ field: { onChange: f, value: g } }) => /* @__PURE__ */ r(
            le,
            {
              ...s,
              toggleId: e.slice(e.lastIndexOf(".") + 1),
              onToggle: (c) => h(c),
              selections: typeof t[0] != "string" ? t.filter((c) => g.includes(c.key)).map((c) => c.value) : g,
              onSelect: (c, v) => {
                if (a === "typeaheadmulti") {
                  const I = v.toString();
                  g.includes(I) ? f(g.filter((k) => k !== I)) : f([...g, I]);
                } else
                  f(v), h(!1);
              },
              onClear: a !== Ce.single ? (c) => {
                c.stopPropagation(), f([]);
              } : void 0,
              isOpen: u,
              variant: a,
              validated: m[e] ? C.error : C.default,
              children: t.map((c) => /* @__PURE__ */ r(
                ae,
                {
                  value: typeof c == "string" ? c : c.key,
                  children: typeof c == "string" ? c : c.value
                },
                typeof c == "string" ? c : c.key
              ))
            }
          )
        }
      )
    }
  );
}, Gn = (e) => {
  const n = e.defaultValue ?? !1, { control: t } = E();
  return /* @__PURE__ */ r(
    A,
    {
      hasNoPaddingTop: !0,
      name: e.name,
      isRequired: e.rules?.required === !0,
      label: e.label,
      labelIcon: e.labelIcon,
      children: /* @__PURE__ */ r(
        O,
        {
          control: t,
          name: e.name,
          defaultValue: n,
          render: ({ field: { onChange: l, value: a } }) => /* @__PURE__ */ r(
            Ie,
            {
              id: e.name,
              "data-testid": e.name,
              label: e.labelOn,
              labelOff: e.labelOff,
              isChecked: e.stringify ? a === "true" : a,
              onChange: (i, s) => {
                const d = e.stringify ? i.toString() : i;
                e.onChange?.(i, s), l(d);
              }
            }
          )
        }
      )
    }
  );
}, M = ne(({ onChange: e, ...n }, t) => /* @__PURE__ */ r(ie, { ...n, ref: t, onChange: (a, i) => e?.(i) }));
M.displayName = "TextInput";
const Bn = (e) => {
  const { labelIcon: n, ...t } = e, l = !!e.rules?.required, a = e.defaultValue ?? "", { field: i, fieldState: s } = oe({
    ...e,
    defaultValue: a
  });
  return /* @__PURE__ */ r(
    A,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: s.error,
      children: /* @__PURE__ */ r(
        M,
        {
          isRequired: l,
          id: e.name,
          "data-testid": e.name,
          validated: s.error ? C.error : C.default,
          isDisabled: e.isDisabled,
          ...t,
          ...i
        }
      )
    }
  );
}, $ = ne(({ onChange: e, ...n }, t) => /* @__PURE__ */ r(we, { ...n, ref: t, onChange: (a, i) => e?.(i) }));
$.displayName = "TextArea";
const Un = (e) => {
  const n = !!e.rules?.required, t = e.defaultValue ?? "", { field: l, fieldState: a } = oe({
    ...e,
    defaultValue: t
  });
  return /* @__PURE__ */ r(
    A,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: a.error,
      children: /* @__PURE__ */ r(
        $,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: a.error ? C.error : C.default,
          isDisabled: e.isDisabled,
          ...l
        }
      )
    }
  );
};
function dn(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Jn = ({
  name: e,
  label: n,
  controller: t,
  labelIcon: l,
  ...a
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = E();
  return /* @__PURE__ */ r(
    A,
    {
      name: e,
      label: n,
      isRequired: t.rules?.required === !0,
      error: s[e],
      labelIcon: l,
      children: /* @__PURE__ */ r(
        O,
        {
          ...t,
          name: e,
          control: i,
          render: ({ field: d }) => {
            const m = !!t.rules?.required, u = dn(t.rules?.min), h = d.value ?? t.defaultValue, f = (g) => d.onChange(
              u !== void 0 ? Math.max(g, Number(u)) : g
            );
            return /* @__PURE__ */ r(
              Te,
              {
                ...a,
                id: e,
                value: h,
                validated: s[e] ? C.error : C.default,
                required: m,
                min: Number(u),
                max: Number(t.rules?.max),
                onPlus: () => f(h + 1),
                onMinus: () => f(h - 1),
                onChange: (g) => {
                  const c = Number(g.currentTarget.value);
                  f(isNaN(c) ? t.defaultValue : c);
                }
              }
            );
          }
        }
      )
    }
  );
}, ue = Q(void 0), Wn = () => X(ue), Kn = ({ children: e }) => {
  const [n, t] = S([]), l = (s) => {
    t((d) => d.filter((m) => m.id !== s));
  }, a = (s, d = F.success, m) => {
    t([
      {
        id: Math.random() * 100,
        message: s,
        variant: d,
        description: m
      },
      ...n
    ]);
  }, i = (s) => {
    a(s, F.danger);
  };
  return /* @__PURE__ */ o(ue.Provider, { value: { addAlert: a, addError: i }, children: [
    /* @__PURE__ */ r(Se, { isToast: !0, "data-testid": "alerts", children: n.map(({ id: s, variant: d, message: m, description: u }) => /* @__PURE__ */ r(
      ke,
      {
        isLiveRegion: !0,
        variant: F[d],
        variantLabel: "",
        title: m,
        actionClose: /* @__PURE__ */ r(
          Ne,
          {
            title: m,
            onClose: () => l(s)
          }
        ),
        timeout: !0,
        onTimeout: () => l(s),
        children: u && /* @__PURE__ */ r("p", { children: u })
      },
      s
    )) }),
    e
  ] });
}, zn = ({ icon: e }) => {
  const n = un(e);
  return /* @__PURE__ */ r(n, { size: "lg", alt: e });
};
function un(e) {
  switch (e) {
    case "github":
      return Ze;
    case "facebook":
      return Xe;
    case "gitlab":
      return Qe;
    case "google":
      return Ye;
    case "linkedin":
    case "linkedin-openid-connect":
      return ze;
    case "openshift-v3":
    case "openshift-v4":
      return Ke;
    case "stackoverflow":
      return We;
    case "twitter":
      return Je;
    case "microsoft":
      return Ue;
    case "bitbucket":
      return Be;
    case "instagram":
      return Ge;
    case "paypal":
      return je;
    default:
      return He;
  }
}
const hn = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, mn = ({
  t: e,
  form: n,
  supportedLocales: t
}) => {
  const l = t.map((a) => ({
    key: a,
    value: hn(a) || ""
  }));
  return l.length ? /* @__PURE__ */ r(Me, { ...n, children: /* @__PURE__ */ r(
    cn,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: l
    }
  ) }) : null;
}, he = (e) => e?.includes("${"), me = (e) => e.substring(2, e.length - 1), x = (e, n, t) => (he(n) ? e(me(n)) : n) || t, D = (e, n) => x(e, n.displayName, n.name), fn = ["username", "firstName", "lastName", "email"], fe = (e) => e && fn.includes(e), w = (e) => `${fe(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, Yn = (e) => e.replaceAll(".", "🍺"), Qn = (e) => e.replaceAll("🍺", ".");
function Xn(e, n, t) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((l) => {
    const a = Object.assign(
      {},
      l.params?.map((i) => t(he(i.toString()) ? me(i) : i))
    );
    n(w(l.field), {
      message: t(l.errorMessage, {
        ...a,
        defaultValue: l.errorMessage || l.field
      }),
      type: "server"
    });
  });
}
function V({
  required: e,
  validators: n
}) {
  return e || gn(n);
}
function gn(e) {
  return e && "length" in e && "min" in e.length && typeof e.length.min == "number" ? e.length.min > 0 : !1;
}
function Zn(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return U(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(U);
}
function U(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const q = ({
  t: e,
  form: n,
  attribute: t,
  renderer: l,
  children: a
}) => {
  const i = t.annotations?.inputHelperTextBefore, {
    formState: { errors: s }
  } = n, d = l?.(t);
  return /* @__PURE__ */ r(
    re,
    {
      label: D(e, t) || "",
      fieldId: t.name,
      isRequired: V(t),
      validated: B(s, w(t.name)) ? "error" : "default",
      helperTextInvalid: e(
        B(s, w(t.name))?.message
      ),
      labelIcon: i ? /* @__PURE__ */ r(de, { helpText: i, fieldLabelId: t.name }) : void 0,
      children: d ? /* @__PURE__ */ o(se, { children: [
        a,
        d
      ] }) : a
    },
    t.name
  );
}, vn = ({
  t: e,
  form: n,
  attribute: t,
  renderer: l,
  ...a
}) => /* @__PURE__ */ r(q, { t: e, form: n, attribute: t, renderer: l, children: /* @__PURE__ */ r(
  pn,
  {
    t: e,
    form: n,
    "aria-label": D(e, t),
    name: w(t.name),
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: D(e, t)
    }),
    ...a
  }
) }), pn = ({
  t: e,
  name: n,
  inputType: t,
  form: l,
  addButtonLabel: a,
  isDisabled: i = !1,
  defaultValue: s,
  id: d,
  ...m
}) => {
  const { register: u, setValue: h, control: f } = l, g = $e({
    name: n,
    control: f,
    defaultValue: s || ""
  }), c = T(() => Array.isArray(g) && g.length !== 0 ? g : s || [""], [g]), v = (b) => {
    _([...c.slice(0, b), ...c.slice(b + 1)]);
  }, I = () => {
    _([...c, ""]);
  }, k = (b, p) => {
    _([...c.slice(0, b), p, ...c.slice(b + 1)]);
  }, _ = (b) => {
    const p = b.flatMap((R) => R);
    h(n, p, {
      shouldDirty: !0
    });
  }, ve = t.startsWith("html") ? t.substring(6) : "text";
  return ee(() => {
    u(n);
  }, [u]), /* @__PURE__ */ r("div", { id: d, children: c.map((b, p) => /* @__PURE__ */ o(te, { children: [
    /* @__PURE__ */ o(se, { children: [
      /* @__PURE__ */ r(
        ie,
        {
          "data-testid": n + p,
          onChange: (R) => k(p, R),
          name: `${n}.${p}.value`,
          value: b,
          isDisabled: i,
          type: ve,
          ...m
        }
      ),
      /* @__PURE__ */ r(
        N,
        {
          "data-testid": "remove" + p,
          variant: H.link,
          onClick: () => v(p),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: c.length === 1 || i,
          children: /* @__PURE__ */ r(en, {})
        }
      )
    ] }),
    p === c.length - 1 && /* @__PURE__ */ o(
      N,
      {
        variant: H.link,
        onClick: I,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !b || i,
        children: [
          /* @__PURE__ */ r(nn, {}),
          " ",
          e(a || "add")
        ]
      }
    )
  ] }, p)) });
}, J = (e) => {
  const { form: n, inputType: t, attribute: l } = e, a = V(l), i = t.startsWith("multiselect"), s = i ? xe : Oe, d = l.validators?.options?.options || [], m = l.annotations?.inputOptionLabels || {};
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    O,
    {
      name: w(l.name),
      control: n.control,
      defaultValue: "",
      render: ({ field: u }) => /* @__PURE__ */ r(L, { children: d.map((h) => /* @__PURE__ */ r(
        s,
        {
          id: h,
          "data-testid": h,
          label: x(e.t, m[h], h),
          value: h,
          isChecked: u.value.includes(h),
          onChange: () => {
            i ? u.value.includes(h) ? u.onChange(
              u.value.filter((f) => f !== h)
            ) : u.onChange([...u.value, h]) : u.onChange([h]);
          },
          readOnly: l.readOnly,
          isRequired: a
        },
        h
      )) })
    }
  ) });
}, W = (e) => {
  const { t: n, form: t, inputType: l, attribute: a } = e, [i, s] = S(!1), d = V(a), m = l === "multiselect", u = (c, v) => {
    m ? v.value.includes(c) ? v.onChange(v.value.filter((I) => I !== c)) : v.onChange([...v.value, c]) : v.onChange(c);
  }, h = a.validators?.options?.options || [], f = a.annotations?.inputOptionLabels || {}, g = (c) => x(e.t, f[c], c);
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    O,
    {
      name: w(a.name),
      defaultValue: "",
      control: t.control,
      render: ({ field: c }) => /* @__PURE__ */ r(
        le,
        {
          toggleId: a.name,
          onToggle: (v) => s(v),
          isCreatable: !0,
          onCreateOption: (v) => u(v, c),
          onSelect: (v, I) => {
            const k = I.toString();
            u(k, c), Array.isArray(c.value) || s(!1);
          },
          selections: c.value ? c.value : m ? [] : n("choose"),
          variant: m ? "typeaheadmulti" : "single",
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: a.readOnly,
          required: d,
          children: ["", ...h].map((v) => /* @__PURE__ */ r(
            ae,
            {
              selected: c.value === v,
              value: v,
              children: v ? g(v) : n("choose")
            },
            v
          ))
        }
      )
    }
  ) });
}, bn = (e) => {
  const { form: n, attribute: t } = e, l = V(t);
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    $,
    {
      id: t.name,
      "data-testid": t.name,
      ...n.register(w(t.name)),
      cols: t.annotations?.inputTypeCols,
      rows: t.annotations?.inputTypeRows,
      readOnly: t.readOnly,
      isRequired: l
    }
  ) });
}, y = (e) => {
  const { form: n, inputType: t, attribute: l } = e, a = V(l), i = t.startsWith("html") ? t.substring(6) : "text";
  return /* @__PURE__ */ r(q, { ...e, children: /* @__PURE__ */ r(
    M,
    {
      id: l.name,
      "data-testid": l.name,
      type: i,
      placeholder: l.annotations?.inputTypePlaceholder,
      readOnly: l.readOnly,
      isRequired: a,
      ...n.register(w(l.name))
    }
  ) });
}, yn = "_invalidCharactersNote_xwh1w_1", Cn = "_toggleLink_xwh1w_17", K = {
  invalidCharactersNote: yn,
  toggleLink: Cn
}, P = {
  text: y,
  textarea: bn,
  select: W,
  "select-radiobuttons": J,
  multiselect: W,
  "multiselect-checkboxes": J,
  "html5-email": y,
  "html5-tel": y,
  "html5-url": y,
  "html5-number": y,
  "html5-range": y,
  "html5-datetime-local": y,
  "html5-date": y,
  "html5-month": y,
  "html5-time": y,
  "multi-input": vn
}, et = ({
  t: e,
  form: n,
  userProfileMetadata: t,
  supportedLocales: l,
  hideReadOnly: a = !1,
  renderer: i
}) => {
  const s = T(() => {
    if (!t.attributes)
      return [];
    const u = a ? t.attributes.filter(({ readOnly: h }) => !h) : t.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...t.groups ?? []
    ].map((h) => ({
      group: h,
      attributes: u.filter(
        (f) => f.group === h.name
      )
    }));
  }, [
    a,
    t.groups,
    t.attributes
  ]), [d, m] = S(!1);
  return s.length === 0 ? null : /* @__PURE__ */ r(
    _n,
    {
      label: e("jumpToSection"),
      sections: s.filter((u) => u.attributes.length > 0).map(({ group: u, attributes: h }) => ({
        title: x(e, u.displayHeader, u.name) || e("general"),
        panel: /* @__PURE__ */ r("div", { children: /* @__PURE__ */ o("div", { className: "pf-c-form", children: [
          u.displayDescription && /* @__PURE__ */ r(Ae, { className: "pf-u-pb-lg", children: x(e, u.displayDescription, "") }),
          h.map((f) => /* @__PURE__ */ o("div", { children: [
            /* @__PURE__ */ r(
              In,
              {
                t: e,
                form: n,
                supportedLocales: l,
                renderer: i,
                attribute: f
              },
              f.name
            ),
            f.name === "username" && /* @__PURE__ */ o("div", { className: "pf-c-form", children: [
              /* @__PURE__ */ r("span", { className: K.toggleLink, onClick: () => m(!d), children: e(d ? "show-invalid-characters-note-list-hide" : "show-invalid-characters-note-list") }),
              d && /* @__PURE__ */ o("div", { className: K.invalidCharactersNote, children: [
                /* @__PURE__ */ r("p", { children: /* @__PURE__ */ o("strong", { children: [
                  e("show-invalid-characters-note-description"),
                  "："
                ] }) }),
                /* @__PURE__ */ o("ul", { children: [
                  /* @__PURE__ */ o("li", { children: [
                    "<（",
                    e("show-invalid-characters-note-1"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    ">（",
                    e("show-invalid-characters-note-2"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "&（",
                    e("show-invalid-characters-note-3"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    '"（',
                    e("show-invalid-characters-note-4"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "'（",
                    e("show-invalid-characters-note-5"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "\\s（",
                    e("show-invalid-characters-note-6"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "\\v（",
                    e("show-invalid-characters-note-7"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "\\h（",
                    e("show-invalid-characters-note-8"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "$（",
                    e("show-invalid-characters-note-9"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "%（",
                    e("show-invalid-characters-note-10"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "!（",
                    e("show-invalid-characters-note-11"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "#（",
                    e("show-invalid-characters-note-12"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "?（",
                    e("show-invalid-characters-note-13"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "§（",
                    e("show-invalid-characters-note-14"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    ",（",
                    e("show-invalid-characters-note-15"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    ";（",
                    e("show-invalid-characters-note-16"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    ":（",
                    e("show-invalid-characters-note-17"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "*（",
                    e("show-invalid-characters-note-18"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "~（",
                    e("show-invalid-characters-note-19"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "/（",
                    e("show-invalid-characters-note-20"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "\\（",
                    e("show-invalid-characters-note-21"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "|（",
                    e("show-invalid-characters-note-22"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "^（",
                    e("show-invalid-characters-note-23"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "=（",
                    e("show-invalid-characters-note-24"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "[（",
                    e("show-invalid-characters-note-25"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "]（",
                    e("show-invalid-characters-note-26"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "{",
                    "（",
                    e("show-invalid-characters-note-27"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "}",
                    "（",
                    e("show-invalid-characters-note-28"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "(",
                    "（",
                    e("show-invalid-characters-note-29"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    ")",
                    "（",
                    e("show-invalid-characters-note-30"),
                    "）"
                  ] }),
                  /* @__PURE__ */ o("li", { children: [
                    "`（",
                    e("show-invalid-characters-note-31"),
                    "）"
                  ] })
                ] })
              ] })
            ] })
          ] }))
        ] }) })
      }))
    }
  );
}, In = ({
  t: e,
  form: n,
  renderer: t,
  supportedLocales: l,
  attribute: a
}) => {
  const i = n.watch(
    w(a.name)
  ), s = T(() => Tn(a), [a]), d = a.multivalued || kn(i) ? P["multi-input"] : P[s];
  return a.name === "locale" ? /* @__PURE__ */ r(
    mn,
    {
      form: n,
      supportedLocales: l,
      t: e,
      attribute: a
    }
  ) : /* @__PURE__ */ r(
    d,
    {
      t: e,
      form: n,
      inputType: s,
      attribute: a,
      renderer: t
    }
  );
}, wn = "text";
function Tn(e) {
  if (fe(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return Sn(n) ? n : wn;
}
const Sn = (e) => typeof e == "string" && e in P, kn = (e) => Array.isArray(e) && e.length > 1, Nn = "_title_tm7j6_3", xn = {
  title: Nn
}, ge = ({
  id: e,
  title: n,
  headingLevel: t = "h1",
  size: l = "xl",
  ...a
}) => /* @__PURE__ */ r(
  Ve,
  {
    headingLevel: t,
    size: l,
    className: xn.title,
    id: e,
    tabIndex: 0,
    ...a,
    children: n
  }
), On = ({
  title: e,
  children: n,
  scrollId: t,
  className: l
}) => {
  const a = pe();
  return /* @__PURE__ */ o(qe, { id: a, className: l, isFlat: !0, children: [
    /* @__PURE__ */ r(Le, { className: "kc-form-panel__header", children: /* @__PURE__ */ r(_e, { tabIndex: 0, children: /* @__PURE__ */ r(ge, { id: t, title: e }) }) }),
    /* @__PURE__ */ r(Re, { className: "kc-form-panel__body", children: n })
  ] });
}, An = (e) => {
  const { title: n, children: t, scrollId: l, ...a } = e;
  return /* @__PURE__ */ r("section", { ...a, style: { marginTop: "var(--pf-global--spacer--lg)" }, children: /* @__PURE__ */ o(L, { children: [
    /* @__PURE__ */ r(ge, { id: l, title: n }),
    t
  ] }) });
}, Vn = "_panel_iariq_1", qn = "_sticky_iariq_9", z = {
  panel: Vn,
  sticky: qn
}, Ln = "kc-main-content-page-container", Y = (e) => e.replace(/\s+/g, "-"), _n = ({
  label: e,
  sections: n,
  borders: t = !1,
  ...l
}) => {
  const a = T(
    () => n.filter(({ isHidden: i }) => !i),
    [n]
  );
  return /* @__PURE__ */ o(Fe, { hasGutter: !0, ...l, children: [
    /* @__PURE__ */ r(j, { md: 8, sm: 12, children: a.map(({ title: i, panel: s }) => {
      const d = Y(i.toLowerCase());
      return /* @__PURE__ */ r(te, { children: t ? /* @__PURE__ */ r(
        On,
        {
          scrollId: d,
          title: i,
          className: z.panel,
          children: s
        }
      ) : /* @__PURE__ */ r(An, { scrollId: d, title: i, children: s }) }, i);
    }) }),
    /* @__PURE__ */ r(j, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ r(De, { className: z.sticky, children: /* @__PURE__ */ r(
      Pe,
      {
        isVertical: !0,
        scrollableSelector: `#${Ln}`,
        label: e,
        offset: 100,
        children: a.map(({ title: i }) => {
          const s = Y(i.toLowerCase());
          return (
            // note that JumpLinks currently does not work with spaces in the href
            /* @__PURE__ */ r(
              Ee,
              {
                href: `#${s}`,
                "data-testid": `jump-link-${s}`,
                children: i
              },
              i
            )
          );
        })
      }
    ) }) })
  ] });
};
export {
  Kn as AlertProvider,
  Hn as ContinueCancelModal,
  On as FormPanel,
  jn as Help,
  de as HelpItem,
  zn as IconMapper,
  $ as KeycloakTextArea,
  M as KeycloakTextInput,
  Jn as NumberControl,
  _n as ScrollForm,
  cn as SelectControl,
  Gn as SwitchControl,
  Un as TextAreaControl,
  Bn as TextControl,
  et as UserProfileFields,
  Yn as beerify,
  tn as createNamedContext,
  Qn as debeerify,
  rn as isDefined,
  Zn as isUserProfileError,
  x as label,
  Ln as mainPageContentId,
  Xn as setUserProfileServerError,
  Wn as useAlerts,
  on as useHelp,
  ln as useRequiredContext,
  sn as useStoredState
};
